<template>
  <section class="link-list">
    <p class="heading">{{ heading }}</p>
    <ul v-if="ce">
      <li>Must have Adobe Reader to view. Translations available in English, Spanish, Italian, French and German.</li>
      <li>Debe tener Adobe Reader para ve. Traducciones disponibles en inglés, español, italiano, francés y alemán.</li>
      <li>È necessario disporre di Adobe Reader per visualizzare. Traduzioni disponibili in inglese, spagnolo, italiano, francese e tedesco.</li>
      <li>Doit avoir Adobe Reader pour visualiser. Traductions disponibles en anglais, espagnol, italien, français et allemand.</li>
      <li>Zum Anzeigen muss Adobe Reader vorhanden sein. Übersetzungen in Englisch, Spanisch, Italienisch, Französisch und Deutsch verfügbar.</li>
    </ul>

    <p
      v-for="(link, index) in links"
      :key="index"
      class="link"
    >
      <a
        :href="link.url"
        target="_blank"
        title="Learn more"
        @click="showModal = true"
      >
        {{ link.title }}
      </a>
    </p>
    <Modal v-if="showModal && ce" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <ul class="modal-list">
            <li>Your User Guide has downloaded</li>
            <li>Su guía del usuario se ha descargado</li>
            <li>La tua guida per l’utente è stata scaricata</li>
            <li>Votre guide de l’utilisateur a été téléchargé</li>
            <li>Ihr Benutzerhandbuch wurde heruntergeladen</li>
          </ul>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </section>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: "linklist",

  components: {
    Modal,
  },

  props: {
    heading: String,
    links: Array,
    ce: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModal: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.link-list {
  margin: 30px 0 40px;
}

.heading {
  font-family: var(--roboto);
  font-size: 1rem;
  line-height: 1.3125;
  font-weight: 700;
  color: var(--black);
}

ul li {
  font-size: 0.875rem;
}

.link {
  margin: 10px 0;
}

.link a {
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  font-weight: 400;
  color: var(--black);
}

.modal-list {
  text-align: left;
}

@media only screen and (min-width: 800px) {
  ::v-deep .modal-container {
      width: 1px;
      width: 40%;
      min-width: auto;
  }
}
</style>